import script from "./PeriodotalMap.vue?vue&type=script&setup=true&lang=ts"
export * from "./PeriodotalMap.vue?vue&type=script&setup=true&lang=ts"

import "./PeriodotalMap.vue?vue&type=style&index=0&id=1665ab4a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1665ab4a"]])

export default __exports__